import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import { Card } from 'antd';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import {app} from '../../config';
import useFetchStates from '../../hooks/fetchStates';
import useFetchCountries from '../../hooks/fetchCountries';

const { TextArea } = Input;
const AddState = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [causeObj, setCauseObj] = useState({
    causeCategory: '',
    isActive: ''
  });
  let user = JSON.parse(localStorage.getItem('user'));
  
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  // console.log(causeCat[0].cause_category);
const s=useFetchStates();
const states=s.response?s.response.data:[];
const c=useFetchCountries();
const countries=c.response?c.response.data:[];
console.log(countries);
  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/state/add`, uploadObj);
      console.log(res);
      window.alert(res.data.message);
      if (res.data.statusCode===200) navigate('/state/view');
    } catch (err) {
      console.log("Error");
      console.log(err);
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  }
  const onFinish = (values) => {
    console.log('Success:', values);
    // o={...values}
    // console.log(values.validityDate.format().split('T')[0]);
    setCauseObj({
      name: values.name ? values.name : '',
      // stateId: values.stateId ? values.stateId : '',
      countryId:values.countryId? values.countryId : '',
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId:user.userId
    });
  };
  console.log(causeObj);
  if(Object.keys(causeObj).length>0)uploadData(causeObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const renderList = []; //For testing purposes
  return (
   
    <div class='container '>
    <div class='row mt-4 w-75 tbl'>
    <div class='row topbar ' style={{ height: '70px' }}>
              <div class='col-lg-4 fs-3 fw-bold'>
                {' '}
                  
                <LeftCircleOutlined
                  onClick={() => {
                    navigate('/state/view');
                  }}
                  className='mt-3 ml-4 back-icon'
                  style={{ fontSize: '38px' }}
                />
              </div>
              <div class='col-lg-7 fs-3 fw-bold '>
                <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add State')} </h2>
              </div>{' '}
            </div>
      <div class="col-lg-11 mb-5 mt-4 ">
      <div class='col-lg-9 align-self-center mt-2 mb-4'>
      <Form
            name='basic'
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              remember: true,
              ['countryId']: 6,
              ['isActive']: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <Form.Item  
              colon={false}
              label='State Name'
              name='name'
              rules={[
                {
                  required: true,
                  message: 'Enter State',
                },
              ]}
            >
              <Input placeholder='Enter State' />
            </Form.Item>
            <Form.Item
              label='Country'
              name='countryId'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                disabled={true}
                placeholder="Select"
                style={{
                  width: 160,
                }}
              >
                {countries.map((country) => {
                  return (
                    <Option key={country.countryId} value={country.countryId}>
                      {country.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
           
            <Form.Item label='Active' valuePropName='checked'  colon={false} name='isActive'>
              <Switch />
            </Form.Item>
            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
              colon={false}
            >
              <button type='primary' class='btn btn-primary button' htmlType='submit'>
                Add
              </button>
            </Form.Item>
          </Form>
      </div>
      </div>
    </div>
    </div>
  );
};

export default AddState;
